<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <router-link class="crumb-home z-font-size-14" to="/icpMain">备案管理</router-link>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14"> 备案审核查看 - ( 订单编号： <span class="crumb-colorblue">{{taskid}}</span> , 备案方式： <span class="crumb-colorblue">{{beianzt.ba_path}}</span> , 当前状态： <span class="crumb-colorblue">{{beianzt.state}}</span> )</a>
        </li>
      </ol>
    </div>
    <div class="card-container ub-box">
      <el-card :body-style="{ padding: '10px 10px 12px 10px' }" class="box-card">
        <span class="z-padding-bottom-8-precent">主办单位信息</span>

          <span v-if="state.zhuti_ok === 1" class="is-done">已完成</span>
          <el-button v-if="state.zhuti_ok === 0" style="padding: 0 " type="text"><i class="el-icon-edit-outline el-icon--left"></i>去填写>></el-button>

      </el-card>
      <el-card :body-style="{ padding: '10px 10px 12px 10px' }" class="box-card">
        <span class="z-padding-bottom-8-precent">ICP备案网站信息</span>

          <span v-if="state.wangzhan_ok === 1" class="is-done">已完成</span>
          <el-button v-if="state.wangzhan_ok === 0" style="padding: 0 " type="text" @click="EditWebInfo"><i class="el-icon-edit-outline el-icon--left"></i>去填写>></el-button>

      </el-card>
      <el-card :body-style="{ padding: '10px 10px 12px 10px' }" class="box-card">
        <span class="z-padding-bottom-8-precent">主办单位照片</span>

          <span v-if="state.zhuti_fj_ok === 1" class="is-done">已上传</span>
          <el-button v-if="state.zhuti_fj_ok === 0" style="padding: 0 " type="text" @click="activeName2 = 'first'">未完成</el-button>

      </el-card>
      <el-card :body-style="{ padding: '10px 10px 12px 10px' }" class="box-card">
        <span class="z-padding-bottom-8-precent">ICP备案网站照片</span>

          <span v-if="state.wangzhan_fj_ok === 1" class="is-done">已上传</span>
          <el-button v-if="state.wangzhan_fj_ok === 0" style="padding: 0 " type="text" @click="activeName2 = 'second'">未完成</el-button>

      </el-card>
      <el-card :body-style="{ padding: '10px 10px 12px 10px' }" class="box-card">
        <span class="z-padding-bottom-8-precent">缴费</span>

          <span v-if="state.pay === '已完成'" class="is-done">已完成</span>
          <el-button v-if="state.pay === '请缴费'" style="padding: 0 " type="text" @click="ipcPay">请缴费</el-button>

      </el-card>
      <el-card :body-style="{ padding: '10px 10px 12px 10px' }" class="box-card">
        <span class="z-padding-bottom-8-precent">审核状态</span>
          <el-button v-if="beianzt.state != '备案成功'" @click="activeName2 = 'third'" style="padding: 0 " type="text">{{beianzt.state}}</el-button>
          <span v-if="beianzt.state === '备案成功'" class="is-done">{{beianzt.state}}</span>

      </el-card>
    </div>
    <div class="page-main beian" v-loading="listLoading">
      <el-tabs v-model="activeName2" type="border-card">
        <el-tab-pane label="主办单位信息" name="first">
          <div v-if="beianzt.state === '初审驳回'" class="z-lineHeight-40 z-margin-bottom-5-precent" style="margin-left: 22px">
            <span class="z-color-red">当前状态为初审驳回，请您重新按照要求进行修改，修改完毕请点击此按钮重新提交</span>
            <el-button size="mini" type="primary"  @click="Reuptask">重新提交</el-button>
          </div>
          <el-row>
            <el-col :span="24"><div class="grid-title bg-purple-blue z-color-fff">
              主办单位信息&nbsp;&nbsp;
              <div v-if="isedit" class="z-display-inlineBlock">
                <xbutton font="编辑" class="z-lineHeight-20" @XbuttonService="dialogInfo = true"/>
              </div>
            </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位名称：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.dwmc}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位性质：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.dwxz}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位有效证件类型：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.zjlx}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位有效证件号码：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.zjhm}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">投资或上级主管单位名称：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.tzr}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位所在城市：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.city.province}} {{info.city.city}} {{info.city.area}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位通讯地址：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.xxdz}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主办单位有效证件地址：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.zjzs}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">负责人姓名：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.fzr_xm}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">手机号码：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.fzr_sjhm}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">有效证件号码：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.fzr_zjhm}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">有效证件类型：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.fzr_zjlx}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">办公电话：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.fzr_dhhm}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">邮件地址：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.fzr_dzyj}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">备案/许可证号：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.ztbah}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">备案提交时间：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.dateline}}</div></el-col>
          </el-row>
          <el-row class="z-margin-bottom-50-precent">
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">最后修改时间：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.zjxgsj}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">备注：</div></el-col>
            <el-col :span="7"><div class="grid-content bg-purple-light">{{info.bz}}</div></el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col class="boder-bottom-none" :span="10">
              <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>{{fjzjlx2}}<a href="https://www.abeiyun.com/help/content_1116.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="info.fj_img_2[0]">大小：{{info.fj_img_2[0].size}} <a :href="info.fj_img_2[0].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
              <div class="img-box img-border boder-top-none">
                <img v-if="info.fj_img_2[0]" :src="info.fj_img_2[0].url" class="avatar">
                <i v-if="!info.fj_img_2[0] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadZt_2"></i>
                <span v-if="info.fj_img_2[0] && isedit" class="avatar-hover" @click="uploadZt_2">
                  <el-button size="small" type="primary" class="avatar-preview"><i class="el-icon-picture-outline el-icon--right"></i> 修改图片</el-button>
                </span>
              </div>
            </el-col>
            <el-col class="boder-bottom-none" :span="10">
              <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>{{fjzjlx3}}<a href="https://www.abeiyun.com/help/content_1116.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="info.fj_img_3[0]">大小：{{info.fj_img_3[0].size}} <a :href="info.fj_img_3[0].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
              <div class="img-box img-border boder-top-none">
                <img v-if="info.fj_img_3[0]" :src="info.fj_img_3[0].url" class="avatar">
                <i v-if="!info.fj_img_3[0] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadZt_3"></i>
                <span v-if="info.fj_img_3[0] && isedit" class="avatar-hover" @click="uploadZt_3">
                  <el-button size="small" type="primary" class="avatar-preview"><i class="el-icon-picture-outline el-icon--right"></i> 修改图片</el-button>
                </span>
              </div>
            </el-col>
          </el-row>
          <el-dialog
            title="修改备案信息"
            :visible.sync="dialogInfo"
            class="dialog"
            :lock-scroll="false"
            width="55%"
            :before-close = "closeDialog">
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位名称：</div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple-light"><el-input v-model="info.dwmc"></el-input></div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位性质：</div></el-col>
              <el-col :span="8">
                <div class="grid-content-left bg-purple-light">
                  <el-select v-model="info.dwxznum" class="z-width-100-precent">
                    <el-option
                      v-for="item in beianInfo.dwxz"
                      :key="item.id"
                      :label="item.mc"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位有效证件类型：</div></el-col>
              <el-col :span="6">
                <div class="grid-content-left bg-purple-light">
                  <el-select v-model="info.zjlxnum" class="z-width-100-precent">
                    <el-option
                      v-for="item in info.zjlxArr"
                      :key="item.id"
                      :label="item.mc"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位有效证件号码：</div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="info.zjhm"></el-input></div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">投资或上级主管单位名称：</div></el-col>
              <el-col :span="19">
                <div class="grid-content-left bg-purple-light">
                  <el-input v-model="info.tzr" class="width-26"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位所在城市：</div></el-col>
              <el-col :span="19">
                <div class="grid-content-left bg-purple-light">
                  <xtable-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo"></xtable-city>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位通讯地址：</div></el-col>
              <el-col :span="19">
                <div class="grid-content-left bg-purple-light">
                  <el-input v-model="info.xxdz"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">主办单位有效证件地址：</div></el-col>
              <el-col :span="19">
                <div class="grid-content-left bg-purple-light">
                  <el-input v-model="info.zjzs"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">负责人姓名：</div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple-light"><el-input v-model="info.fzr_xm"></el-input></div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark">有效证件类型：</div></el-col>
              <el-col :span="8">
                <div class="grid-content-left bg-purple-light">
                  <el-select v-model="info.fzr_zjlxnum" class="z-width-100-precent">
                    <el-option
                      v-for="item in info.fzr_zjlx_arr"
                      :key="item.id"
                      :label="item.mc"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">有效证件号码：</div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple-light"><el-input v-model="info.fzr_zjhm"></el-input></div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark">办公电话：</div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="info.fzr_dhhm"></el-input></div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">手机号码：</div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple-light"><el-input v-model="info.fzr_sjhm"></el-input></div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark">邮件地址：</div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="info.fzr_dzyj"></el-input></div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark">备案/许可证号：</div></el-col>
              <el-col :span="6"><div class="grid-content bg-purple-light"><el-input v-model="info.ztbah"></el-input></div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark">备案密码：</div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="info.icpmm"></el-input></div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark" style="min-height: 66px;line-height: 66px;">备注：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple-light" style="padding-top: 6px"><el-input type="textarea" v-model="info.bz"></el-input></el-input></div></el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="closeInfo"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="editInfo"></xbutton></span>
            </span>
          </el-dialog>
          <el-dialog
            title="上传图片"
            :visible.sync="dialogzt_3"
            class="dialog"
            :lock-scroll="false"
            :close-on-click-modal="false"
            width="30%"
            top="30vh">
            <el-upload
              class="upload-demo"
              action="https://api.abeiyun.com/www/beian.php"
              name="fj_img"
              :limit="1"
              :file-list="fileList"
              :with-credentials="true"
              :data="uploadData"
              :on-success="successZt_3"
              :before-upload="dialogLoading"
              v-loading="dialogloading"
              element-loading-background="rgba(255, 255, 255, 0.3)">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
          </el-dialog>
          <el-dialog
            title="上传图片"
            :visible.sync="dialogzt_2"
            class="dialog"
            :lock-scroll="false"
            :close-on-click-modal="false"
            width="30%"
            top="30vh">
            <el-upload
              class="upload-demo"
              action="https://api.abeiyun.com/www/beian.php"
              name="fj_img"
              :limit="1"
              :file-list="fileList"
              :with-credentials="true"
              :data="uploadData"
              :on-success="successZt_2"
              :before-upload="dialogLoading"
              v-loading="dialogloading"
              element-loading-background="rgba(255, 255, 255, 0.3)">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="ICP备案网站信息" name="second">
          <!--<div v-for="option in wangzhan" class="z-margin-bottom-50-precent">
          <xvertical-table :tableData="option.wztop" :tablehead="tablehead2" :isedit="isedit"/>
          <xonever-table :tableData="option.wzbottom"/>
          </div>-->
          <div v-if="beianzt.state === '初审驳回'" class="z-lineHeight-40 z-margin-bottom-5-precent" style="margin-left: 22px">
            <span class="z-color-red">当前状态为初审驳回，请您重新按照要求进行修改，修改完毕请点击此按钮重新提交</span>
            <el-button size="mini" type="primary"  @click="Reuptask">重新提交</el-button>
          </div>
          <div v-if="beianzt.ba_path === '首次备案' && wangzhan.length < 3 && beianzt.state != '备案成功' && beianzt.state != '内部初审' && beianzt.state != '管局审核'" class="z-textAlign-center z-lineHeight-40 z-margin-bottom-10-precent">
            <el-button type="primary" @click="EditWebInfo">添加</el-button>
          </div>
          <div v-if="wangzhan.length > 0" v-for="(item, index) in wangzhan">
            <el-row>
              <el-col :span="24"><div class="grid-title bg-purple-blue z-color-fff">
                ICP备案网站信息&nbsp;&nbsp;
                <div v-if="isedit" class="z-display-inlineBlock">
                  <xbutton font="编辑" class="z-lineHeight-20" @XbuttonService="wzIdx = index,dialogWangzhan = true"/>
                </div>
                <el-button v-if="beianzt.ba_path === '首次备案' && beianzt.state != '备案成功' && beianzt.state != '内部初审' && beianzt.state != '管局审核'" type="danger" size="mini" @click="wangzhanDel(item.wzxtid)">删除</el-button>
              </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">网站名称：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.wzmc}}</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">网站备案号：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.baxh}}</div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">网站首页网址：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">
                <a :href="item.url" style="color:#337ab7">{{item.syurl}}</a>
              </div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">负责人姓名：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.fzr_xm}}</div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">手机号码：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.fzr_sjhm}}</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">有效证件类型：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.fzr_zjlx}}</div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">办公电话：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.fzr_dhhm}}</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">有效证件号码：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.fzr_zjhm}}</div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">邮件地址：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.fzr_dzyj}}</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">主体备案号：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.ztbah}}</div></el-col>
            </el-row>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">备注：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.wz_bz}}</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">备案密码：</div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple-light">{{item.icpmm}}</div></el-col>
            </el-row>
            <table cellspacing="0" cellpadding="0" border="0" style="width: 100%">
              <tr>
                <td class="col-5 grid-content bg-purple-dark z-textAlign-right">语言类别：</td>
                <td class="grid-content bg-purple-light">
                  <span v-for="option in item.copyyylb">
                    {{option}}
                  </span>
                </td>
              </tr>
            </table>
            <el-row>
              <el-col :span="5"><div class="grid-content bg-purple-dark z-textAlign-right">服务内容：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple-light">{{item.copywzfwlx}}</div></el-col>
            </el-row>
            <table cellspacing="0" cellpadding="0" border="0" style="width: 100%">
              <tr>
                <td class="col-5 grid-content bg-purple-dark z-textAlign-right">网站域名：</td>
                <td class="grid-content bg-purple-light">
                  <span v-for="option in item.ym">
                    {{option.ym}}&nbsp;
                    <i v-if="isedit" class="close_btn" @click="wzIdx = index,ymxtid = option.ymxtid,deldomain = option.ym,dialogdeldomain = true"></i>
                  </span>
                  <div v-if="isedit" class="z-display-inlineBlock z-lineHeight-16">
                    <xbutton font="添加域名" type="addjieru" :optionStyle="{fontSize:'12px'}" @XbuttonService="adddomain = '',wzIdx = index,dialogadddomain = true"/>
                  </div>
                </td>
              </tr>
            </table>
            <table v-if="beianzt.state != '备案成功'" cellspacing="0" cellpadding="0" border="0" style="width: 100%">
              <tr>
                <td class="col-5 grid-content bg-purple-dark z-textAlign-right">接入信息：</td>
                <td class="grid-content bg-purple-light">
                  <span v-for="option in item.jieru">
                    {{option.mc}}&nbsp;
                    <i v-if="isedit" class="close_btn" @click="wzIdx = index,jrxtid = option.id,delIp = option.ip,dialogdeljieru = true"></i>
                  </span>
                  <div v-if="isedit" class="z-display-inlineBlock z-lineHeight-16">
                    <xbutton font="添加接入" type="addjieru" :optionStyle="{fontSize:'12px'}" @XbuttonService="addIp = '',wzIdx = index,dialogaddjieru = true"/>
                  </div>
                </td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" style="width: 100%">
              <tr>
                <td class="col-5 grid-content bg-purple-dark z-textAlign-right">前置审批：</td>
                <td class="grid-content bg-purple-light">
                  <div v-for="option in item.qzsp" class="qianzhi">
                    <p>前置审批号：{{option.Qzsph}} </p>
                    <p>前置审批内容类型：{{option.Nrlx}} </p>
                    <img :src="option.FileName" alt="" class="qianzhi-img">
                  </div>
                </td>
              </tr>
            </table>
            <el-row :gutter="50" class="z-margin-top-30-precent">
              <el-col class="boder-bottom-none" :span="8">
                <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>{{fjzjlx4}}<a href="https://www.abeiyun.com/help/content_1116.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="item.fj_img_4[0]">大小：{{item.fj_img_4[0].size}} <a :href="item.fj_img_4[0].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
                <div class="img-box img-border boder-top-none">
                  <img v-if="item.fj_img_4[0]" :src="item.fj_img_4[0].url" class="avatar">
                  <i v-if="!item.fj_img_4[0] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadWz_4(index)"></i>
                  <span v-if="item.fj_img_4[0] && isedit" class="avatar-hover" @click="uploadWz_4(index)">
                    <el-button size="small" type="primary" class="avatar-preview"><i class="el-icon-picture-outline el-icon--right"></i> 修改图片</el-button>
                  </span>
                </div>
              </el-col>
              <el-col class="boder-bottom-none" :span="8">
                <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>{{fjzjlx5}}<a href="https://www.abeiyun.com/help/content_1123.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="item.fj_img_5[0]">大小：{{item.fj_img_5[0].size}} <a :href="item.fj_img_5[0].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
                <div class="img-box img-border boder-top-none">
                  <img v-if="item.fj_img_5[0]" :src="item.fj_img_5[0].url" class="avatar">
                  <i v-if="!item.fj_img_5[0] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadWz_5(index)"></i>
                  <span v-if="item.fj_img_5[0] && isedit" class="avatar-hover" @click="uploadWz_5(index)">
                    <el-button size="small" type="primary" class="avatar-preview"><i class="el-icon-picture-outline el-icon--right"></i> 修改图片</el-button>
                  </span>
                </div>
              </el-col>
              <el-col class="boder-bottom-none" :span="8">
                <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>{{fjzjlx1}}<a href="https://www.abeiyun.com/help/content_1143.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="item.fj_img_1[0]">大小：{{item.fj_img_1[0].size}} <a :href="item.fj_img_1[0].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
                <div class="img-box img-border boder-top-none">
                  <img v-if="item.fj_img_1[0]" :src="item.fj_img_1[0].url" class="avatar">
                  <i v-if="!item.fj_img_1[0] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadWz_1f(index)"></i>
                  <span v-if="item.fj_img_1[0] && isedit" class="avatar-hover">
                    <span class="avatar-delete iconfont icon-chahao" @click.stop="delf(index)"></span>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="50" v-if="item.fj_img_1[0]">
              <el-col class="boder-bottom-none" :span="8">
                <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>域名证书<a href="https://www.abeiyun.com/help/content_1117.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="item.fj_img_1[1]">大小：{{item.fj_img_1[1].size}} <a :href="item.fj_img_1[1].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
                <div class="img-box img-border boder-top-none">
                  <img v-if="item.fj_img_1[1]" :src="item.fj_img_1[1].url" class="avatar">
                  <i v-if="!item.fj_img_1[1] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadWz_1s(index)"></i>
                  <span v-if="item.fj_img_1[1] && isedit" class="avatar-hover">
                    <span class="avatar-delete iconfont icon-chahao" @click.stop="dels(index)"></span>
                  </span>
                </div>
              </el-col>
              <el-col v-if="item.fj_img_1[1]" class="boder-bottom-none" :span="8">
                <span class="ub-box ub-between z-lineHeight-25 bg-purple-blue z-color-fff z-padding-h-10-precent img-border boder-bottom-none"><span>授权书(个人备案无需上传)<a href="https://www.abeiyun.com/help/content_1141.html" class="z-curPonit z-color-yellow" target="_blank">&nbsp;&nbsp;：查看示例</a></span><span v-if="item.fj_img_1[2]">大小：{{item.fj_img_1[2].size}} <a :href="item.fj_img_1[2].url" class="z-curPonit z-color-yellow" target="_blank">查看原图</a></span></span>
                <div class="img-box img-border boder-top-none">
                  <img v-if="item.fj_img_1[2]" :src="item.fj_img_1[2].url" class="avatar">
                  <i v-if="!item.fj_img_1[2] && isedit" class="el-icon-plus avatar-uploader-icon" @click="uploadWz_1t(index)"></i>
                  <span v-if="item.fj_img_1[2] && isedit" class="avatar-hover">
                    <span class="avatar-delete iconfont icon-chahao" @click.stop="delt(index)"></span>
                  </span>
                </div>
              </el-col>
            </el-row>
            <div v-if="index != wangzhan.length-1" class="wanzhan-bottom" style=""></div>
            <el-dialog
              title="修改网站系统"
              :visible.sync="dialogWangzhan"
              class="dialog"
              :lock-scroll="false"
              width="50%"
              :before-close = "closeDialog">
              <el-row>
                <el-col :span="4"><div class="grid-content bg-purple-dark">主办单位名称：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].wzmc"></el-input></div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple-dark">网站首页地址：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].syurl"></el-input></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="4"><div class="grid-content bg-purple-dark">有效证件类型：</div></el-col>
                <el-col :span="8">
                  <div class="grid-content-left bg-purple-light">
                    <select v-model="wangzhan[wzIdx].fzr_zjlxnum" class="wz-select">
                      <option v-for="item in beianInfo.zjlx" :value="item.id" class="wz-option">{{item.mc}}</option>
                    </select>
                  </div>
                </el-col>
                <el-col :span="4"><div class="grid-content bg-purple-dark">有效证件号码：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].fzr_zjhm"></el-input></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="4"><div class="grid-content bg-purple-dark">手机号码：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].fzr_sjhm"></el-input></div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple-dark">办公电话：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].fzr_dhhm"></el-input></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="4"><div class="grid-content bg-purple-dark">姓名：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].fzr_xm"></el-input></div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple-dark">电子邮箱：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].fzr_dzyj"></el-input></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="4"><div class="grid-content bg-purple-dark">备注：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].wz_bz"></el-input></div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple-dark">网站备案号：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].baxh"></el-input></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="4"><div class="grid-content bg-purple-dark">主体备案号：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].ztbah"></el-input></div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple-dark">备案密码：</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light"><el-input v-model="wangzhan[wzIdx].icpmm"></el-input></div></el-col>
              </el-row>
              <table cellspacing="0" cellpadding="0" border="0" style="width: 100%">
                <tr>
                  <td class="col-4 grid-content bg-purple-dark z-textAlign-right" style="border-top: 1px solid #ddd; min-height: 35px; line-height: 35px;">语言类别：</td>
                  <td class="grid-content-left bg-purple-light" style="border-top: 1px solid #ddd; min-height: 35px; line-height: 35px;">
                    <label v-for="option in beianInfo.yylb">
                      <input type="checkbox" :value="option.id" v-model="wangzhan[wzIdx].yylb">
                      {{option.mc}}
                    </label>
                  </td>
                </tr>
              </table>
              <table cellspacing="0" cellpadding="0" border="0" style="width: 100%">
                <tr>
                  <td class="col-4 grid-content bg-purple-dark z-textAlign-right" style="min-height: 38px; line-height: 38px;">服务内容：</td>
                  <td class="grid-content-left bg-purple-light" style="min-height: 38px; line-height: 38px;">
                    <label v-for="option in beianInfo.wzfwlx">
                      <input type="radio" name="fuwu" :value="option.id" v-model="wangzhan[wzIdx].wzfwlx">
                      {{option.mc}}
                    </label>
                  </td>
                </tr>
              </table>
              <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="closeWangzhan"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="editWangzhan(wzIdx)"></xbutton></span>
            </span>
            </el-dialog>
            <el-dialog
              title="添加接入"
              :visible.sync="dialogaddjieru"
              class="dialog"
              :lock-scroll="false"
              width="30%"
              top="30vh">
              <div class="bg-purple-dark z-padding-left-50-precent z-lineHeight-40">
                IP地址：
                <el-input class="z-display-inlineBlock z-width-60-precent" v-model="addIp"></el-input>
              </div>
              <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="dialogaddjieru = false"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="addJieru(wzIdx)"></xbutton></span>
            </span>
            </el-dialog>
            <el-dialog
              title="删除接入IP"
              :visible.sync="dialogdeljieru"
              class="dialog"
              :lock-scroll="false"
              width="30%"
              top="30vh">
              <div class="z-font-size-16 z-padding-left-50-precent z-lineHeight-30">
                请确认是否删除该网站接入IP {{delIp}}
              </div>
              <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="dialogdeljieru = false"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="delJieru(wzIdx)"></xbutton></span>
            </span>
            </el-dialog>
            <el-dialog
              title="添加域名"
              :visible.sync="dialogadddomain"
              class="dialog"
              :lock-scroll="false"
              width="30%"
              top="30vh">
              <div class="bg-purple-dark z-padding-left-50-precent z-lineHeight-40">
                域名名称：
                <el-input class="z-display-inlineBlock z-width-60-precent" v-model="adddomain"></el-input>
              </div>
              <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="dialogadddomain = false"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="addDomain(wzIdx)"></xbutton></span>
            </span>
            </el-dialog>
            <el-dialog
              title="删除域名"
              :visible.sync="dialogdeldomain"
              class="dialog"
              :lock-scroll="false"
              width="30%"
              top="30vh">
              <div class="z-font-size-16 z-padding-left-50-precent z-lineHeight-30">
                请确认是否删除该网站域名{{deldomain}}？
              </div>
              <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="dialogdeldomain = false"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="delDomain(wzIdx)"></xbutton></span>
            </span>
            </el-dialog>
            <el-dialog
              title="上传图片"
              :visible.sync="dialogwz_4"
              class="dialog"
              :lock-scroll="false"
              :close-on-click-modal="false"
              width="30%"
              top="30vh">
              <el-upload
                class="upload-demo"
                action="https://api.abeiyun.com/www/beian.php"
                name="fj_img"
                :limit="1"
                :file-list="fileList"
                :with-credentials="true"
                :data="uploadData"
                :on-success="successWz_4"
                :before-upload="dialogLoading"
                v-loading="dialogloading"
                element-loading-background="rgba(255, 255, 255, 0.3)">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
            </el-dialog>
            <el-dialog
              title="上传图片"
              :visible.sync="dialogwz_5"
              class="dialog"
              :lock-scroll="false"
              :close-on-click-modal="false"
              width="30%"
              top="30vh">
              <el-upload
                class="upload-demo"
                action="https://api.abeiyun.com/www/beian.php"
                name="fj_img"
                :limit="1"
                :file-list="fileList"
                :with-credentials="true"
                :data="uploadData"
                :on-success="successWz_5"
                :before-upload="dialogLoading"
                v-loading="dialogloading"
                element-loading-background="rgba(255, 255, 255, 0.3)">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
            </el-dialog>
            <el-dialog
              title="上传图片"
              :visible.sync="dialogwz_1f"
              class="dialog"
              :lock-scroll="false"
              :close-on-click-modal="false"
              width="30%"
              top="30vh">
              <el-upload
                class="upload-demo"
                action="https://api.abeiyun.com/www/beian.php"
                name="fj_img"
                :limit="1"
                :file-list="fileList"
                :with-credentials="true"
                :data="uploadData"
                :on-success="successWz_1f"
                :before-upload="dialogLoading"
                v-loading="dialogloading"
                element-loading-background="rgba(255, 255, 255, 0.3)">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
            </el-dialog>
            <el-dialog
              title="上传图片"
              :visible.sync="dialogwz_1s"
              class="dialog"
              :lock-scroll="false"
              :close-on-click-modal="false"
              width="30%"
              top="30vh">
              <el-upload
                class="upload-demo"
                action="https://api.abeiyun.com/www/beian.php"
                name="fj_img"
                :limit="1"
                :file-list="fileList"
                :with-credentials="true"
                :data="uploadData"
                :on-success="successWz_1s"
                :before-upload="dialogLoading"
                v-loading="dialogloading"
                element-loading-background="rgba(255, 255, 255, 0.3)">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
            </el-dialog>
            <el-dialog
              title="上传图片"
              :visible.sync="dialogwz_1t"
              class="dialog"
              :lock-scroll="false"
              :close-on-click-modal="false"
              width="30%"
              top="30vh">
              <el-upload
                class="upload-demo"
                action="https://api.abeiyun.com/www/beian.php"
                name="fj_img"
                :limit="1"
                :file-list="fileList"
                :with-credentials="true"
                :data="uploadData"
                :on-success="successWz_1t"
                :before-upload="dialogLoading"
                v-loading="dialogloading"
                element-loading-background="rgba(255, 255, 255, 0.3)">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            <span slot="footer" class="dialog-footer">
            </span>
            </el-dialog>
          </div>
        </el-tab-pane>
        <el-tab-pane label="进度说明" name="third">
          <div v-if="beianzt.state === '初审驳回'" class="z-lineHeight-40 z-margin-bottom-5-precent" style="margin-left: 22px">
            <span class="z-color-red">当前状态为初审驳回，请您重新按照要求进行修改，修改完毕请点击此按钮重新提交</span>
            <el-button size="mini" type="primary"  @click="Reuptask">重新提交</el-button>
          </div>
          <el-table :data="jindu" highlight-current-row show-header style="width: 100%;">
            <el-table-column prop="id" label="序号" max-width="50" align="left">
            </el-table-column>
            <el-table-column prop="addtime" label="操作时间" min-width="200" align="left">
            </el-table-column>
            <el-table-column prop="jindu" label="进度状态" max-width="200" align="left">
            </el-table-column>
            <el-table-column prop="jindu_shuoming" label="进度说明" min-width="500" align="left">
            </el-table-column>
            <el-table-column prop="ztbah" label="内部说明" max-width="200" align="left">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="支付工本费"
        :visible.sync="dialogpay"
        class="dialog"
        :lock-scroll="false"
        width="40%"
        top="30vh">
        <el-row>
          <el-col :span="24"><div class="grid-content" style="text-align: center">支付备案工本费</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><div class="grid-content" style="text-align: left">
            账户余额：
            <span class="z-font-size-14 z-font-weight-700 z-color-red">￥ {{pay.money}}</span>
          </div></el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><div class="grid-content" style="text-align: left">
            备案工本费：
            <span class="z-font-size-14 z-font-weight-700 z-color-red">￥ {{pay.usemoney}}</span>
            &nbsp;&nbsp;&nbsp;使用优惠券：
            <el-select v-model="pay.coupon" placeholder="--请选择--" style="width: 450px">
              <el-option
                v-for="item in pay.yhq"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><div class="grid-content" style="text-align: center">
            <el-button type="primary" @click="saveIcpPay">提交</el-button>
          </div>
          </el-col>
        </el-row>
      </el-dialog>
      <xdialog-loading :dialogLoading="dialogLoading2"></xdialog-loading>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import Xtable from 'components/commons/Xtable.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import XtableCity from 'components/commons/XtableCity.vue'
  import beianService from 'business/beianService.js'
  import userService from 'business/userService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data() {
      return {
        listLoading:false,
        dialogloading:false,
        dialogLoading2:false,
        dialogInfo:false,
        dialogWangzhan:false,
        dialogaddjieru:false,
        dialogdeljieru:false,
        dialogadddomain:false,
        dialogdeldomain:false,
        dialogzt_3:false,
        dialogzt_2:false,
        dialogwz_4:false,
        dialogwz_5:false,
        dialogwz_1f:false,
        dialogwz_1s:false,
        dialogwz_1t:false,
        dialogpay:false,
        beianInfo:{},
        DISTRICTS:[],
        DISTRICTS2:[],
        beianZt:{},
        activeName2: 'first',
        beianzt:{},//sesstion
        tablehead1:'主办单位信息',
        tablehead2:'ICP备案网站信息',
        info: {
          ztxtid:'',
          dwmc:'',
          dwxz:'',
          zjlx:'',
          dwxznum:'',
          zjlxnum:'',
          zjhm:'',
          tzr:'',
          city:{
            province:'',
            city:'',
            area:''
          },
          xxdz:'',
          zjzs:'',
          fzr_xm:'',
          fzr_sjhm:'',
          fzr_zjhm:'',
          fzr_zjlx:'',
          fzr_zjlxnum:'',
          fzr_dhhm:'',
          fzr_dzyj:'',
          ztbah:'',
          dateline:'',
          zjxgsj:'',
          bz:'',
          icpmm:'',
          fj_img_2:[{
            mc:'',
            fjxtid:'',
            url:'',
            fjyt:'',
            size:''
          }],
          fj_img_3:[{
            mc:'',
            fjxtid:'',
            url:'',
            fjyt:'',
            size:''
          }],
        },
        fjzjlx3:'',
        fjzjlx2:'',
        fjzjlx4:'',
        fjzjlx5:'',
        fjzjlx1:'',
        wangzhan: [],
        wzIdx:0,
        addIp:'',
        delIp:'',
        jrxtid:'',//接入信息接入系统ID
        adddomain:'',
        deldomain:'',
        ymxtid:'',//域名系统ID
        jindu:[],
        cityInfo: {
          province:'北京市',
          city:'市辖区',
          area:'东城区'
        },
        taskid:'',
        ba_path_id:'',
        isedit:false,
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 1
        },
        fileList:[],
        fjxtid:'',
        uploadData:{},
        state:{
          zhuti_ok:'',
          wangzhan_ok:'',
          zhuti_fj_ok:'',
          wangzhan_fj_ok:'',
          pay:'',
        },
        pay:{
          money:'',
          usemoney:'',
          coupon:'',
          yhq:[],
        }
      };
    },
    components:{
      Xtable,
      Xbutton,
      XtableCity,
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.activeName2 = sessionStorage.getItem('tabs') ? sessionStorage.getItem('tabs') : 'first'
      this.config()
    },
    computed: {
      nature() {
        return this.info.dwxznum
      },
    },
    watch:{
      nature(val, oldVal){
        this.info.zjlxArr = [...this.beianInfo.zjlx.filter(item => item.dwflid === this.info.dwxznum)]
        if(oldVal != ''){
          if(this.info.zjlxArr.length>0){
            this.info.zjlxnum = this.info.zjlxArr[0].id
          }
        }
      },
    },
    methods:{
      ...mapActions(['FIRSTBEIAN']),
      async config() {
        this.beianzt = {'id': this.$route.params.id}
        await Promise.all([this.getZt(), this.get_dm()]);
        this.getInfo()
      },
      async get_dm() {
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST','cmd=get_dm')
        if(state.code === '000' ) {
          this.beianInfo = vueData
          this.DISTRICTS = vueData.qy
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async getZt() {
        this.listLoading = true
        let {vueData, state} = await beianService.transformToVue('beianZt','POST','cmd=ba_zt_list')
        if(state.code === '000'){
          this.beianZt = vueData
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async getInfo() {
        let data = 'cmd=query_task'+'&taskid='+ this.beianzt.id
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(state.code === '000') {
          this.beianzt.ba_path = vueData.task.ba_path
          this.beianzt.state = vueData.task.zt
          if(this.beianzt.state === '初审驳回' || this.beianzt.state === '准备任务'){
            this.isedit = true
          }
          this.taskid = vueData.task.id
          this.ba_path = vueData.task.ba_path
          this.ba_path_id = vueData.task.ba_path_id
          let state = vueData.state
          let info = vueData.zhuti.info[0]
          let dwxz = (info.dwxz && info.dwxz != '0') ? [...this.beianInfo.dwxz.filter(item => item.id === info.dwxz)][0].mc : ''
          let zjlx = (info.zjlx && info.zjlx != '0') ? [...this.beianInfo.zjlx.filter(item => item.id === info.zjlx)][0].mc : ''
          let fzr_zjlx_arr = [...this.beianInfo.zjlx.filter(item => item.dwflid == 5)]
          let fzr_zjlx = (info.fzr_zjlx && info.fzr_zjlx != '0') ? [...this.beianInfo.zjlx.filter(item => item.id === info.fzr_zjlx)][0].mc : ''
          let wzjrfs = this.beianInfo.wzjrfs
          let fwqdd = this.beianInfo.fwqdd
          let wzjylx = this.beianInfo.wzjylx
          for(let i in this.DISTRICTS){
            if(this.DISTRICTS[i].id == info.shengid){
              this.cityInfo.province = this.DISTRICTS[i].mc
              let province = this.DISTRICTS[i].shi
              for(let j in province){
                if(province[j].id == info.shiid){
                  this.cityInfo.city = province[j].mc
                  let city = province[j].xian
                  for(let k in city){
                    if(city[k].id == info.xianid){
                      this.cityInfo.area = city[k].mc
                    }
                  }
                }
              }
            }
          }
          this.fjzjlx3 = [...this.beianInfo.fjzjlx.filter(items => items.id === '3')][0].mc
          this.fjzjlx2 = [...this.beianInfo.fjzjlx.filter(items => items.id === '2')][0].mc
          this.fjzjlx4 = [...this.beianInfo.fjzjlx.filter(items => items.id === '4')][0].mc
          this.fjzjlx5 = [...this.beianInfo.fjzjlx.filter(items => items.id === '5')][0].mc
          this.fjzjlx1 = [...this.beianInfo.fjzjlx.filter(items => items.id === '1')][0].mc
          let fj_imgs = info.fj_img.map(item => {
            return {
              mc:[...this.beianInfo.fjzjlx.filter(items => items.id === item.Fjyt)][0].mc,
              fjxtid:item.fjxtid,
              url:item.url,
              fjyt:item.Fjyt,
              size:item.size
            }
            })
          this.state = {
            zhuti_ok:state.zhuti_ok,
            wangzhan_ok:state.wangzhan_ok,
            zhuti_fj_ok:state.zhuti_fj_ok,
            wangzhan_fj_ok:state.wangzhan_fj_ok,
            pay:state.pay,
          },
          this.info = {
              ztxtid:info.ztxtid,
              dwmc:info.dwmc,
              dwxz:dwxz,
              zjlx:zjlx,
              zjlxArr:this.beianInfo.zjlx,
              dwxznum:(info.dwxz && info.dwxz !='0') ? info.dwxz : '5',
              zjlxnum:(info.zjlx && info.zjlx !='0') ? info.zjlx : '2',
              zjhm:info.zjhm,
              tzr:info.tzr,
              city:{
                province:this.cityInfo.province,
                city:this.cityInfo.city,
                area:this.cityInfo.area
              },
              xxdz:info.xxdz,
              zjzs:info.zjzs,
              fzr_xm:info.fzr_xm,
              fzr_sjhm:info.fzr_sjhm,
              fzr_zjhm:info.fzr_zjhm,
              fzr_zjlx:fzr_zjlx,
              fzr_zjlx_arr:fzr_zjlx_arr,
              fzr_zjlxnum:(info.fzr_zjlx && info.fzr_zjlx !='0') ? info.fzr_zjlx : '2',
              fzr_dhhm:info.fzr_dhhm,
              fzr_dzyj:info.fzr_dzyj,
              ztbah:info.ztbah ? info.ztbah : '',
              icpmm:info.icpmm ? info.icpmm : '',
              dateline:info.dateline,
              zjxgsj:info.zjxgsj,
              bz:info.bz,
              fj_img_2:fj_imgs.filter(items => {
                return items.fjyt === '2'
              }),
              fj_img_3:fj_imgs.filter(items => {
                return items.fjyt === '3'
              }),
          },
          this.listLoading = false
          if(vueData.zhuti.wangzhan.length != 0){
            this.wangzhan = vueData.zhuti.wangzhan.map(item => {
              let fzr_zjlx = (item.fzr_zjlx && item.fzr_zjlx !='0') ? [...this.beianInfo.zjlx.filter(items => items.id === item.fzr_zjlx)][0].mc : ''
              let fj_imgs = item.fj_img.map(items => {
                return {
                  mc:[...this.beianInfo.fjzjlx.filter(itemes => itemes.id === items.Fjyt)][0].mc,
                  fjxtid:items.fjxtid,
                  url:items.url,
                  fjyt:items.Fjyt,
                  size:items.size
                }
              })
              return {
                wzxtid:item.wzxtid,
                wzmc:item.wzmc,
                baxh:item.baxh ? item.baxh : '',
                syurl:item.syurl,
                url:'http://'+item.syurl,
                fzr_xm:item.fzr_xm,
                fzr_sjhm:item.fzr_sjhm,
                fzr_zjlx:fzr_zjlx,
                fzr_zjlxnum:item.fzr_zjlx,
                fzr_dhhm:item.fzr_dhhm,
                fzr_zjhm:item.fzr_zjhm,
                fzr_dzyj:item.fzr_dzyj,
                wz_bz:item.wz_bz,
                ztbah:item.ztbah,
                icpmm:item.icpmm,
                yylb:item.yylb_id,
                copyyylb:item.yylb_id.map(items => {
                  return items ? [...this.beianInfo.yylb.filter(itemes => itemes.id === items)][0].mc : ''
                }),
                copywzfwlx:[...this.beianInfo.wzfwlx.filter(itemes => itemes.id === item.fwnr_id)][0].mc,
                wzfwlx:item.fwnr_id,
                ym:item.ym,
                jieru:item.jieru.map(items =>{
                  let jrfs = [...wzjrfs.filter(item => item.id === items.jrfs)][0].mc
                  let fbdd = [...fwqdd.filter(item => item.id === items.fbdd)][0].mc
                  return{
                    mc:'('+ fbdd +'/ '+ jrfs +'/'+ items.ip+')',
                    id:items.jrxtid,
                    ip:items.ip
                  }
                }),
                qzsp:item.qzsp.map(items =>{
                  let Nrlx = [...wzjylx.filter(item => item.id === items.Nrlx_id)][0].mc
                  return{
                    Qzsph:items.Qzsph,
                    Nrlx:Nrlx,
                    FileName:items.FileName
                  }
                }),
                fj_img_4:fj_imgs.filter(items => {
                  return items.fjyt === '4'
                }),
                fj_img_5:fj_imgs.filter(items => {
                  return items.fjyt === '5'
                }),
                fj_img_1:fj_imgs.filter(items => {
                  return items.fjyt === '1'
                }),
              }
            })
          }else{
            this.wangzhan = []
          }
          if(vueData.jindu.length != 0){
            this.jindu = vueData.jindu.map((item, index) => {
              let zjlx
              for(let i in this.beianZt){
                if(i == item.jindu){
                  zjlx = this.beianZt[i]
                }
              }
              return {
                id:index+1,
                addtime:item.addtime,
                jindu:zjlx,
                jindu_shuoming:item.jindu_shuoming,
                ztbah:item.ztbah,
                state:item.zt,
              }
            })
          }

        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      closeDialog(done){
        this.getInfo().then(_ => {
          done()
        })
      },
      async editInfo() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].mc == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].id)
            let province = this.DISTRICTS[i].shi
            for(let j in province){
              if(province[j].mc == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].id)
                let city = province[j].xian
                for(let k in city){
                  if(city[k].mc == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].id)
                  }
                }
              }
            }
          }
        }
        let icpmm = this.icpmm ? this.icpmm : ''
        let data = 'cmd=zhuti_edit'
          +'&cmd_type=edit'
          +'&taskid='+ this.taskid
          +'&ztxtid='+ this.info.ztxtid
          +'&dwmc=' + this.info.dwmc
          +'&dwxz=' + this.info.dwxznum
          +'&zjlx=' + this.info.zjlxnum
          +'&zjhm=' + this.info.zjhm
          +'&zjzs=' + this.info.zjzs
          +'&tzr=' + this.info.tzr
          +'&xxdz=' + this.info.xxdz
          +'&shengid=' + this.cityId.provinceid
          +'&shiid=' + this.cityId.cityid
          +'&xianid=' + this.cityId.districtid
          +'&fzr_xm=' + this.info.fzr_xm
          +'&fzr_sjhm=' + this.info.fzr_sjhm
          +'&fzr_dhhm=' + this.info.fzr_dhhm
          +'&fzr_zjlx=' + this.info.fzr_zjlxnum
          +'&fzr_zjhm=' + this.info.fzr_zjhm
          +'&fzr_dzyj=' + this.info.fzr_dzyj
          +'&ztbah=' + this.info.ztbah
          +'&icpmm=' + icpmm
          +'&bz=' + this.info.bz
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.getInfo()
          this.dialogInfo = false
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      closeInfo() {
        this.getInfo()
        this.dialogInfo = false
      },
      async editWangzhan(idx) {
        let yylbid = this.wangzhan[idx].yylb.toString()
        let data = 'cmd=wangzhan_edit'
          +'&cmd_type=edit'
          +'&ba_path='+ this.ba_path_id
          +'&wzxtid='+ this.wangzhan[idx].wzxtid
          +'&wzmc=' + this.wangzhan[idx].wzmc
          +'&syurl=' + this.wangzhan[idx].syurl
          +'&fwnr_id=' + this.wangzhan[idx].wzfwlx
          +'&yylb_id=' + yylbid
          +'&fzr_xm=' + this.wangzhan[idx].fzr_xm
          +'&fzr_zjlx=' + this.wangzhan[idx].fzr_zjlxnum
          +'&fzr_zjhm=' + this.wangzhan[idx].fzr_zjhm
          +'&fzr_sjhm=' + this.wangzhan[idx].fzr_sjhm
          +'&fzr_dzyj=' + this.wangzhan[idx].fzr_dzyj
          +'&wz_bz=' + this.wangzhan[idx].wz_bz
          +'&fzr_dhhm=' + this.wangzhan[idx].fzr_dhhm
          +'&baxh=' + this.wangzhan[idx].baxh
          +'&ztbah=' + this.wangzhan[idx].ztbah
          +'&icpmm=' + this.wangzhan[idx].icpmm
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.getInfo()
          this.dialogWangzhan = false
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      closeWangzhan() {
        this.getInfo()
        this.dialogWangzhan = false
      },
      async addJieru(idx) {
        let data = 'cmd=jr_edit'
          +'&cmd_type=add'
          +'&ip='+this.addIp
          +'&wzxtid='+this.wangzhan[idx].wzxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.getInfo()
          this.dialogaddjieru = false
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      async delJieru(idx) {
        let data = 'cmd=jr_edit'
          +'&cmd_type=del'
          +'&wzxtid='+this.wangzhan[idx].wzxtid
          +'&jrxtid='+this.jrxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.getInfo()
          this.dialogdeljieru = false
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      async addDomain(idx) {
        let data = 'cmd=ym_edit'
          +'&cmd_type=add'
          +'&ym='+this.adddomain
          +'&wzxtid='+this.wangzhan[idx].wzxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.getInfo()
          this.dialogadddomain = false
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      async delDomain(idx) {
        let data = 'cmd=ym_edit'
          +'&cmd_type=del'
          +'&wzxtid='+this.wangzhan[idx].wzxtid
          +'&ymxtid='+this.ymxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.getInfo()
          this.dialogdeldomain = false
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      dialogLoading () {
        this.dialogloading = true
      },
      async uploadZt_3() {
        this.dialogzt_3 = true
        this.uploadData = {
          cmd:'img_edit',
          cmd_type:'add',
          ztxtid:this.info.ztxtid,
          ssdxlx:'1',
          fjyt:'3',
          fjxtid:this.info.fj_img_3[0] ? this.info.fj_img_3[0].fjxtid : ''
        }
      },
      successZt_3(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogzt_3 = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      async uploadZt_2() {
        this.dialogzt_2 = true
        this.uploadData = {
          cmd:'img_edit',
          cmd_type:'add',
          ztxtid:this.info.ztxtid,
          ssdxlx:'1',
          fjyt:'2',
          fjxtid:this.info.fj_img_2[0] ? this.info.fj_img_2[0].fjxtid : ''
        }
      },
      successZt_2(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogzt_2 = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      async uploadWz_4(idx) {
        this.dialogwz_4 = true
        this.wzIdx = idx
        this.uploadData = {
          cmd:'img_edit',
          cmd_type:'add',
          wzxtid:this.wangzhan[this.wzIdx].wzxtid,
          ssdxlx:'2',
          fjyt:'4',
          fjxtid:this.wangzhan[this.wzIdx].fj_img_4[0] ? this.wangzhan[this.wzIdx].fj_img_4[0].fjxtid : ''
        }
      },
      successWz_4(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogwz_4 = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      async uploadWz_5(idx) {
        this.dialogwz_5 = true
        this.wzIdx = idx
        this.uploadData = {
          cmd:'img_edit',
          cmd_type:'add',
          wzxtid:this.wangzhan[this.wzIdx].wzxtid,
          ssdxlx:'2',
          fjyt:'5',
          fjxtid:this.wangzhan[this.wzIdx].fj_img_5[0] ? this.wangzhan[this.wzIdx].fj_img_5[0].fjxtid : ''
        }
      },
      successWz_5(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogwz_5 = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      async uploadWz_1f(idx) {
        this.dialogwz_1f = true
        this.wzIdx = idx
        this.uploadData = {
          cmd:'img_edit',
          cmd_type:'add',
          wzxtid:this.wangzhan[this.wzIdx].wzxtid,
          ssdxlx:'2',
          fjyt:'1',
          fjxtid:this.wangzhan[this.wzIdx].fj_img_1[0] ? this.wangzhan[this.wzIdx].fj_img_1[0].fjxtid : ''
        }
      },
      successWz_1f(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogwz_1f = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      async uploadWz_1s(idx) {
        this.dialogwz_1s = true
        this.wzIdx = idx
        this.uploadData = {
          cmd:'img_edit',
          cmd_type:'add',
          wzxtid:this.wangzhan[this.wzIdx].wzxtid,
          ssdxlx:'2',
          fjyt:'1',
          fjxtid:this.wangzhan[this.wzIdx].fj_img_1[1] ? this.wangzhan[this.wzIdx].fj_img_1[1].fjxtid : ''
        }
      },
      successWz_1s(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogwz_1s = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      uploadWz_1t(idx) {
        this.dialogwz_1t = true
        this.wzIdx = idx
        this.uploadData = {
            cmd:'img_edit',
            cmd_type:'add',
            wzxtid:this.wangzhan[this.wzIdx].wzxtid,
            ssdxlx:'2',
            fjyt:'1',
            fjxtid:this.wangzhan[this.wzIdx].fj_img_1[2] ? this.wangzhan[this.wzIdx].fj_img_1[2].fjxtid : ''
        }
      },
      successWz_1t(res){
        if(res.response == 200){
          this.dialogloading = false
          this.dialogwz_1t = false
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(res.msg,'fail')
          this.dialogloading = false
          this.fileList = []
        }
      },
      async delf(idx){
        let data = 'cmd=img_edit'
          +'&cmd_type=del'
          +'&fjxtid='+ this.wangzhan[idx].fj_img_1[0].fjxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo', 'POST', data);
        if(vueData.response == 200){
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      async dels(idx){
        let data = 'cmd=img_edit'
          +'&cmd_type=del'
          +'&fjxtid='+ this.wangzhan[idx].fj_img_1[1].fjxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo', 'POST', data);
        if(vueData.response == 200){
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      async delt(idx){
        let data = 'cmd=img_edit'
          +'&cmd_type=del'
          +'&fjxtid='+ this.wangzhan[idx].fj_img_1[2].fjxtid
        let {vueData, state} = await beianService.transformToVue('beianInfo', 'POST', data);
        if(vueData.response == 200){
          this.fileList = []
          this.getInfo()
        }else{
          this.$toast(vueData.msg,'fail')
        }
      },
      EditWebInfo(){
        this.FIRSTBEIAN(JSON.stringify({
          taskid:this.taskid,
          ztxtid:this.info.ztxtid,
          beian_path:this.ba_path_id
        }))
        this.$router.push('/beian9')
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          let onuse = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.pay.money = vueData.msg.money
          this.pay.yhq = onuse
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async ipcPay() {
        let data = 'cmd=beian_money'+
          '&task_id=' + this.taskid
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.couponInfo()
          this.dialogpay = true
          this.pay.usemoney = vueData.price
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async saveIcpPay() {
        this.dialogLoading2 = true
        let data = 'cmd=save_icp_pay'+
          '&yhq_id='+ this.pay.coupon +
          '&task_id=' + this.taskid
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogpay = false
          this.dialogLoading2 = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.getInfo()}})
        }else {
          this.dialogpay = false
          this.dialogLoading2 = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async wangzhanDel(id) {
        MessageBox.confirm('确定要删除此网站吗?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading2 = true
          let data = 'cmd=wangzhan_del'+
            '&taskid='+ this.taskid +
            '&wzxtid='+ id
          let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading2 = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.getInfo()}})
          }else {
            this.dialogLoading2 = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async Reuptask() {
        MessageBox.confirm('请确认已经修改完毕，提交后将进入内部审核状态，无法再自助修改。', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading2 = true
          let data = 'cmd=reup_task'+
            '&task_id='+ this.taskid
          let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading2 = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.getInfo()}})
          }else {
            this.dialogLoading2 = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .page-main { border: 0;}
  .breadcrumb li:last-child a {
    color: #999;
  }
  .crumb-colorblue{
    color: #009FD9;
    font-size: 14px;
  }
  .dialog .el-col {
    border-top: 1px solid #ddd;
    border-bottom: 0;
  }
  .el-col {
    border-bottom: 1px solid #ddd;
  }
  .grid-title {
    line-height: 50px;
    padding-left: 8px;
  }
  .grid-img-title {
    line-height: 32px;
    padding-left: 8px;
  }
  .bg-purple-blue {
    background: #0b99f3;
  }
  .bg-purple-dark {
    background: #eef1f6;
  }
  .bg-purple-light {
    background: #fff;
  }
  .dialog .bg-purple-light {
    padding: 0 3rem 0 0.5rem;
  }
  .dialog .grid-content {
    min-height: 46px;
    line-height: 46px;
    text-align: right;
  }
  .dialog .grid-content-left {
    min-height: 46px;
    line-height: 46px;
    text-align: left;
  }
  .dialog .boder-top-none {
    border-top: 0;
  }
  .grid-content {
    min-height: 33px;
    line-height: 33px;
    padding: 0 8px;
  }
  .width-26 {
    width: 25.75%;
  }
  .col-5 {
    width: 20.83332%;
  }
  .col-4 {
    width: 16.69%;
  }
  table td{
    vertical-align: middle;
    -webkit-transition: background-color .25s ease;
    transition: background-color .25s ease;
    border-bottom: 1px solid #ddd;
    padding: 8px 0;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
  }
  table span {
    position: relative;
    padding-right: 20px;
  }
  .qianzhi {
    width: 30%;
    height: 200px;
    margin: 10px;
    border: 1px solid #ccc;
    float: left;
    position: relative;
    padding-left: 5px;
  }
  .qianzhi-img {
    max-width: 100%;
    max-height: 60%;
  }
  .wz-select {
    height: 32px;
    width: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding-left: 11px;
    font-size: 13px;
    color: #606266;
  }
  .wz-select .wz-option {
    padding-left: 11px;
    font-size: 13px;
  }
  .close_btn {
    width: 12px;
    height: 12px;
    top: -4px;
    right: 13px;
    position: absolute;
    background: url(../../assets/imgs/close_btn.png) no-repeat center/cover;
    cursor: pointer;
  }
  .avatar-uploader {
    position: relative;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-size: 60px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    margin: 30% auto;
  }
  .img-box {
    box-sizing: border-box;
    position: relative;
    text-align: center;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
  .img-border {
    border: 1px solid #ccc;
  }
  .boder-bottom-none {
    border-bottom: 0;
  }
  .boder-top-none {
    border-top: 0;
  }
  .avatar {
    width: 100%;
  }
  .avatar-hover {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0,0,0,.3);
    transition: opacity .3s;
  }
  .avatar-hover:hover {
    opacity: 1;
  }
  .avatar-delete {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  .avatar-preview {
    position: absolute;
    top: 46%;
    left: 43%;
  }
  .el-icon-picture-outline {
    font-size: 14px;
    vertical-align: text-bottom;
  }
  .card-container{
    margin:20px;
  }
  .box-card {
    color: #666;
    width: 190px;
    margin-right: 20px;
  }
  .el-icon-edit-outline {
    font-size: 14px;
    vertical-align: text-bottom;
  }
  .is-done{
    color:#83CE97;
  }
  .wanzhan-bottom {
    height: 50px;
    background-color: #f6f5fa;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/icpContent.vue